import { createSlice } from "@reduxjs/toolkit";
import {      contractNote_processThunk } from "./thunk";


export const initialState = {
  contractNote_processData: [],
  contractNote_processError: {
    code: null,
    message: '',
    data: null
  },
  contractNote_processLoading: false,
  
  
};

const ContractNote_Process = createSlice({
  name: "ContractNote_Process",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(contractNote_processThunk.pending, (state) => {
      state.contractNote_processLoading = true ;
      state.contractNote_processError = initialState.contractNote_processError; 
  });
    builder.addCase(contractNote_processThunk.fulfilled, (state, action) => {
        state.contractNote_processData = action.payload.data;
        state.contractNote_processLoading = false ;
    });
    builder.addCase(contractNote_processThunk.rejected, (state, action) => {
      state.contractNote_processError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.contractNote_processLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = ContractNote_Process.actions

export default ContractNote_Process.reducer;